var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('json_editor_value',{attrs:{"multiple":_vm.multiple,"config_columns":_vm.config_columns,"action_columns_picking":_vm.action_columns_picking,"data":_vm.c_data,"level":1,"index":_vm.index,"id_action":_vm.id_action},on:{"get":_vm.get}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }